<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Freight Consolidation - Export</b-navbar-brand>
        </b-navbar>

        <banner-component :allModuleIdBanner="ffFclConsoModel.allModuleId ? ffFclConsoModel.allModuleId : ''
          " :jobSeriesBanner="ffFclConsoModel.ffExportFclConsoSeries
            ? ffFclConsoModel.ffExportFclConsoSeries
            : ''
            " :bannerClientName="ffFclConsoModel.clientName ? ffFclConsoModel.clientName : ''"
          :trackingId="trackingId != '' ? trackingId : ''" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button v-if="ffFclConsoModel.ffFclConsoExportId != ''" @click="addStatus" class="md-fab">
                  <md-icon class="icon-1">message</md-icon>
                </md-button>
              </md-layout>
            </md-layout>

            <StatusAlerts :SUBS_alerts="SUBSAlerts" />

            <b-row>
              <b-col cols="3">
                <label for="containerInfo">FF Activity Type</label>
                <model-list-select :list="containerInfoList" v-model="ffFclConsoModel.containerInfo"
                  option-value="containerInfoVal" option-text="containerInfoText" placeholder="Select FF Activity"
                  :isDisabled="ExecutionDisable == '' ? false : true"></model-list-select>
              </b-col>
              <b-col cols="3">
                <label for="shippingId">Shipping Line Name</label>
                <model-list-select :list="shippingList" v-model="ffFclConsoModel.shippingId" option-value="shippingId"
                  option-text="shippingLine" placeholder="Select Shipping Line"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.shippingId">{{
                  ffFclConsoModelError.shippingId
                }}</span>
              </b-col>
              <b-col cols="3">
                <label for="stuffingType">Stuffing Type</label>
                <model-list-select :list="stuffingTypeList" v-model="ffFclConsoModel.stuffingType" isDisabled
                  option-value="stuffingTypeVal" option-text="stuffingTypeText"
                  placeholder="Select Stuffing Type"></model-list-select>
              </b-col>
              <b-col cols="3">
                <label for="deliveryMode">Destination Delivery Mode</label>
                <model-list-select :list="deliveryModeList" v-model="ffFclConsoModel.deliveryMode"
                  option-value="deliveryModeVal" option-text="deliveryModeText"
                  placeholder="Select Delivery Mode"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.deliveryMode">{{
                  ffFclConsoModelError.deliveryMode
                }}</span>
              </b-col>
              <b-col cols="3"><label>Container Type/Size</label>
                <model-list-select option-value="containerTypeId"
                  @input="getContainerTypeDet(ffFclConsoModel.containerTypeId)" option-text="containerType"
                  :list="ContainerTypeList" placeholder="Select Container Type/Size"
                  v-model="ffFclConsoModel.containerTypeId"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.containerTypeId">{{
                  ffFclConsoModelError.containerTypeId
                }}</span>
              </b-col>
              <b-col cols="3">
                <label>COUNT of CONTAINERS<span class="error">*</span></label>
                <b-form-input :formatter="capitalizeAll" id="no_of_container" name="no_of_container"
                  v-model="ffFclConsoModel.no_of_container"></b-form-input>
                <span class="error" v-if="!ffFclConsoModel.no_of_container">{{
                  ffFclConsoModelError.no_of_container
                }}</span>
              </b-col>
              <b-col cols="3">
                <label for="shipmentType">Source of Booking</label>
                <model-list-select :list="shipTypeList" v-model="ffFclConsoModel.shipType" option-value="shipTypeVal"
                  option-text="shipTypeText" placeholder="Select Source"></model-list-select>
              </b-col>
              <b-col cols="3" v-if="ffFclConsoModel.containerInfo == 'LclConsolidation'">
                <label>Enter Co-­Loader Name</label>
                <b-form-input :formatter="capitalizeAll" id="coloaderName" name="coloaderName"
                  v-model="ffFclConsoModel.coloaderName"></b-form-input>
              </b-col>
              <b-col cols="3" v-if="ffFclConsoModel.shipType != ''"><label for="bookingSourceclientId">Booking
                  Party</label>
                <model-list-select :list="clientList" id="clientNamenew" v-model="ffFclConsoModel.bookingSourceclientId"
                  option-value="clientId" option-text="clientName"
                  placeholder="Select Booking Party"></model-list-select></b-col>
              <b-col cols="3">
                <label for="agentName">Agent Name</label>
                <model-list-select :list="$store.getters['common/getAllAgentColoaderList']
                  " option-value="agentName" option-text="agentName" v-model="ffFclConsoModel.agentName" :placeholder="'Select Agent Name'
                    " @input="getAgentDetails"></model-list-select>
                <!-- <model-list-select :list="agentNameList" v-model="ffFclConsoModel.agentName" option-value="agentNameVal"
                  option-text="agentNameText" placeholder="Select Agent Name"></model-list-select> --></b-col>
              <b-col cols="3">
                <label>Buyer Name</label>
                <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer"
                  v-model="ffFclConsoModel.buyer"></b-form-input></b-col>
              <b-col cols="3"><label for="PORlocationId">Place of Receipt</label>

                <!-- IcdPOrtListNew -->
                <model-list-select @input="getLocationList($event, 'Icd,Sea_Port_India', 'IcdPOrtList')" @searchchange="
                  getLocationList($event, 'Icd,Sea_Port_India', 'IcdPOrtList')
                  " :list="$store.getters['common/getAllPORList']" v-model="ffFclConsoModel.PORlocationId"
                  option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Place of Receipt"></model-list-select>
                <!-- :isDisabled="ExecutionDisable == '' ? false : true" -->
                <span class="error" v-if="!ffFclConsoModel.PORlocationId">{{
                  ffFclConsoModelError.PORlocationId
                }}</span></b-col>
              <!-- :isDisabled="ffFclConsoModel.portType == 'Icd'
                    ? ExecutionDisable == ''
                      ? false
                      : true
                    : true
                    "  -->
              <b-col cols="3"> <label for="LPlocationId">Load Port Name</label>
                <model-list-select @input="getLocationList($event, 'Sea_Port', 'PortLoadList')"
                  @searchchange="getLocationList($event, 'Sea_Port', 'PortLoadList')" :list="PortLoadList"
                  v-model="ffFclConsoModel.LPlocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Load Port Name"
                  :isError="ffFclConsoModel.portType == 'Icd' ? false : true"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.LPlocationId">{{
                  ffFclConsoModelError.LPlocationId
                }}</span></b-col>
              <b-col cols="3"> <label>Free Time At Origin(In Days)</label>
                <b-form-input :formatter="capitalizeAll" type="number" min="0" id="freeTimeAtOrigin"
                  name="freeTimeAtOrigin" v-model="ffFclConsoModel.freeTimeAtOrigin"></b-form-input></b-col>
              <b-col cols="3"> <label for="PODLocationId">Port of Discharge</label>
                <model-list-select @input="
                  getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
                  " @searchchange="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
                    " :list="getPortDischargeList" v-model="ffFclConsoModel.PODLocationId" option-value="pickupId"
                  option-text="pickupLocation" placeholder="Select Port of Discharge"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.PODLocationId">{{
                  ffFclConsoModelError.PODLocationId
                }}</span></b-col>
              <b-col cols="3"><label for="finalPlaceLocationId">Final Place of Delivery</label>
                <model-list-select @input="
                  getLocationList($event, 'Sea_Port_NonIndia', 'finalAllPlaceData')
                  " @searchchange="
                    getLocationList($event, 'Sea_Port_NonIndia', 'finalAllPlaceData')
                    " :list="finalAllPlaceData" v-model="ffFclConsoModel.finalPlaceLocationId" option-value="pickupId"
                  option-text="pickupLocation" placeholder="Select FPOD"></model-list-select>
                <span class="error" v-if="!ffFclConsoModel.finalPlaceLocationId">{{
                  ffFclConsoModelError.finalPlaceLocationId
                }}</span></b-col>
              <b-col cols="3"> <label>Free Time At Destination(Days)</label>
                <b-form-input :formatter="capitalizeAll" type="number" min="0" id="freeTimeAtDestination"
                  name="freeTimeAtDestination" v-model="ffFclConsoModel.freeTimeAtDestination"></b-form-input>
              </b-col>
              <b-col cols="3" v-if="ffFclConsoModel.portType == 'Icd'">
                <label for="pdaDetail">PDA Details</label>
                <model-list-select :list="pdaDetailList" v-model="ffFclConsoModel.pdaDetail"
                  option-value="pdaDetailsVal" option-text="pdaDetailsText" placeholder="Select PDA "
                  :isDisabled="ExecutionDisable == '' ? false : true"></model-list-select>
              </b-col>
              <b-col cols="3" v-if="newJobType.indexOf('CC') >= 0">
                <label for="ccType">CC Type</label>
                <model-list-select :list="cctypeList" v-model="ffFclConsoModel.ccType" option-value="ccTypeVal"
                  option-text="ccTypeTxt" placeholder="Select CC Type"></model-list-select></b-col>
              <b-col cols="3" v-if="ffFclConsoModel.ccType == 'Outsourced'">
                <label>CHA Name</label>
                <b-form-input :formatter="capitalizeAll" id="ccCha" name="ccCha"
                  v-model="ffFclConsoModel.ccCha"></b-form-input></b-col>
              <b-col cols="12"><label>Remarks</label>
                <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
                  v-model="ffFclConsoModel.remark"></b-form-textarea></b-col>

            </b-row>
            <hr class="hr-s" />
            <b-row v-if="showClientDiv == true || ffFclConsoModel.ffFclConsoExportId == ''">
              <b-col cols="12"> <label>
                  <b>
                    <u>Multiple Client Details</u>
                  </b>
                </label></b-col>
              <b-col cols="3"> <label for="clientId">Shipper Name</label>
                <model-list-select :list="clientList" id="clientNamenew" v-model="fclConsoMultipleModel.clientId"
                  option-value="clientId" option-text="clientName"
                  placeholder="Select Shipper Name"></model-list-select>
                <span class="error" v-if="!fclConsoMultipleModel.clientId">{{
                  fclConsoMultipleModelError.clientId
                }}</span></b-col>
              <b-col cols="3">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select :list="deliveryTermsList" v-model="fclConsoMultipleModel.deliveryTerms"
                  option-value="deliveryTermsVal" option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"></model-list-select>
                <span class="error" v-if="!fclConsoMultipleModel.deliveryTerms">{{
                  fclConsoMultipleModelError.deliveryTerms
                }}</span>
              </b-col>
              <b-col cols="3"> <label for="autoCommodity">Commodity-HSN Code</label>
                <model-list-select @searchchange="getCommodityList($event, 'getCommodityData')" :list="commodityList"
                  v-model="fclConsoMultipleModel.commodityId" option-value="commodityId" option-text="itemHSNCode"
                  placeholder="Select Commodity"></model-list-select></b-col>
              <b-col cols="3"><label for="commodityType">Commodity Type</label>
                <model-list-select :list="commodityTypeName" v-model="fclConsoMultipleModel.commodityType"
                  option-value="commodityTypeVal" option-text="commodityTypeText"
                  placeholder="Select Commodity Type"></model-list-select></b-col>
              <b-col cols="3"><b-button variant="primary" @click="openCommodityModal()" id="addButtonLoader"
                  size="sm">Add</b-button></b-col>

              <b-col cols="3" v-if="fclConsoMultipleModel.commodityType == 'Reefer'"> <label>Temperature Req(Degree
                  Celsius)</label>
                <b-form-input :formatter="capitalizeAll" id="temperatureRequired" name="temperatureRequired"
                  v-model="fclConsoMultipleModel.temperatureRequired"></b-form-input></b-col>

              <b-col cols="3" v-if="fclConsoMultipleModel.commodityType == 'Others'"> <label>Specific Detail if
                  any..!</label>
                <b-form-input :formatter="capitalizeAll" id="otherComodity" name="otherComodity"
                  v-model="fclConsoMultipleModel.otherComodity"></b-form-input></b-col>
            </b-row>
            <b-row v-if="fclConsoMultipleModel.commodityType == 'Hazardous'">
              <b-col cols="3"><label>IMDG Class</label>
                <b-form-input :formatter="capitalizeAll" id="IMDGClass" name="IMDGClass"
                  v-model="fclConsoMultipleModel.IMDGClass"></b-form-input></b-col>
              <b-col cols="3"><label>UN Number</label>
                <b-form-input :formatter="capitalizeAll" id="UNNumber" name="UNNumber"
                  v-model="fclConsoMultipleModel.UNNumber"></b-form-input></b-col>
              <b-col cols="3"> <label>Packing Code</label>
                <b-form-input :formatter="capitalizeAll" id="packingCode" name="packingCode"
                  v-model="fclConsoMultipleModel.packingCode"></b-form-input></b-col>
            </b-row>
            <b-row>

              <b-col cols="12"><label>
                  <b>
                    <u>Additional Task</u>
                  </b>
                </label></b-col>
              <b-col cols="3" v-for="(otherServiceNameArray, index) in showOtherServiceArray" :key="index">
                <md-checkbox v-model="fclConsoMultipleModel.otherServices[index]" class="md-primary"
                  :md-value="otherServiceNameArray.value" :name="'otherServices' + (index + 1)"
                  :id="'otherServices' + (index + 1)" @change="
                    otherServiceNameArraySelect(otherServiceNameArray.value, index)
                    ">{{ otherServiceNameArray.show }}</md-checkbox></b-col>
              <b-col cols="12"><label>
                  <b>
                    <u>More Additional Tas</u>
                  </b>
                </label></b-col>
              <b-col cols="3">
                <md-input-container>
                  <label for="additionalMoreTask">More Additional Task</label>
                  <md-select placeholder="Click for More Additional Task" name="additionalMoreTask"
                    id="additionalMoreTask" multiple v-model="fclConsoMultipleModel.additionalMoreTask"
                    @change="showMultiple">
                    <md-option v-for="(AdditionalMoreArray, index) in showAdditionalMoreTaskArray" :key="index"
                      :value="AdditionalMoreArray">{{ AdditionalMoreArray.show }}</md-option>
                  </md-select>
                </md-input-container>
              </b-col>
              <b-col cols="3" v-if="showAdd"><label>Specify Additional Task</label>
                <b-form-input :formatter="capitalizeAll" id="specificAdditionalTask" name="specificAdditionalTask"
                  v-model="fclConsoMultipleModel.specificAdditionalTask"></b-form-input></b-col>
              <b-col cols="3"><md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                  id="addButtonLoaderMultiple" style="margin-top: -40px" @click="addMultipleClient">{{
                    fclConsoMultipleModel.fclConsoMultipleClientId == "" ? "Add" : "Edit"
                  }}
                  client</md-button>
                <md-spinner md-indeterminate id="loaderMultiple" style="display: none"></md-spinner></b-col>
              <hr class="hr-border" v-if="FclConsoDetailArray.length > 0" />
              <b-col cols="12">
                <div class="box" v-if="FclConsoDetailArray.length > 0">
                  <div class="box-header">
                    <h3 class="box-title">
                      <u>Client Details</u>
                    </h3>
                    <b-button v-if="this.showClientDiv == false" @click="addMoreClient" size="sm" variant="outline-info"
                      class="pull-right">Add More Client</b-button>
                  </div>
                  <!-- /.box-header -->
                  <div class="table-responsive tableMain">
                    <table id="FreghtContaner" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr.no</th>
                          <th>Client Name</th>
                          <th>Delievery Terms</th>
                          <th>Commodity</th>
                          <th>Additional Task</th>
                          <th>More Additional Task</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item1, index) in FclConsoDetailArray" :key="index">
                          <td>{{ index + 1 }}</td>

                          <td @click="viewEditMul(item1)" class="showMoreData">
                            {{ item1.myclientName }}
                          </td>
                          <td>
                            {{ item1.deliveryTerms }}
                            <p class="error" v-if="!item1.deliveryTerms">
                              Delivery Terms Field is Required!
                            </p>
                          </td>
                          <td>
                            {{ item1.commodityId }}
                            <p class="error" v-if="item1.commodityId === '0'">
                              Commodity Field is Required!
                            </p>
                          </td>

                          <td>
                            {{ item1.otherServices == "" ? "--" : item1.otherServices }}
                          </td>
                          <td>
                            {{
                              item1.moreAdditionalTask == "" ? "--" : item1.moreAdditionalTask
                            }}
                          </td>
                          <td>
                            <md-button v-if="
                              $sessionsStorage.get('designation') == 'Admin' &&
                              $sessionsStorage.get('nameUser') == 'Bhavneesh'
                            " class="md-icon-button md-raised md-dense" @click="removeCommon(item1)">
                              <md-icon>delete_sweep</md-icon>
                            </md-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- /.box-body -->
                </div>
              </b-col>
              <md-layout md-gutter class="mt-3 justify-content-center" v-if="FclConsoDetailArray.length > 0">
                <!-- <md-layout md-flex="45"></md-layout> -->
                <b-button variant="primary" id="addButtonLoaderS" @click="ProceedBookingOrder">Save & Proceed to
                  Booking</b-button>
                <md-spinner md-indeterminate id="loaderS" style="display: none"></md-spinner>
              </md-layout>

              <b-col lg="12">
                <span class="error pull-right" v-if="ffFclConsoModel.FFExportFCLCreated">
                  <b> {{ ffFclConsoModel.FFExportFCLCreated }}</b>
                </span>
              </b-col>

              <b-col lg="12">
                <span class="error pull-right" v-if="ffFclConsoModel.FFExportFCLUpdated">
                  <b> {{ ffFclConsoModel.FFExportFCLUpdated }}</b>
                </span>
              </b-col>
            </b-row>
            <hr class="hr-border" />

          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <!-- Commodity Modal Added By Priyanshu Singh Start -->
    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="Commodity-modal" hide-footer title="Add Commodity">
      <b-row class="justify-content-center">
        <b-col md="4">
          <label>Item Name <span class="error">*</span></label>
          <b-form-input size="sm" :formatter="capitalizeAll" id="itemName" name="itemName"
            v-model="commodityModal.itemName"></b-form-input>
          <span class="error" v-if="!commodityModal.itemName">{{
            errorList.itemName
          }}</span>
        </b-col>
        <b-col md="4">
          <label>HSN Code <span class="error">*</span></label>
          <b-form-input size="sm" :formatter="capitalizeAll" id="hsnCode" name="hsnCode"
            v-model="commodityModal.hsnCode"></b-form-input>
          <span class="error" v-if="!commodityModal.hsnCode">{{
            errorList.hsnCode
          }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button variant="outline-primary" @click="addCommodity" id="addButtonLoader" size="sm">Save</b-button>
          <b-button variant="outline-danger" size="sm" class="ml-2" @click="hideCommodityModal">Close</b-button>
          <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Commodity Modal Added By Priyanshu Singh Start -->
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopInsert"
      @close="ProceedNext"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE } from "../../helper/constant.js";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import ClientUserService from "../../services/ClientUserService.js";
import {
  globalPermissionStatus,
  GlobalGetCommodity,
  GlobalGetCommodity2,
  GlobalGetLocation,
} from "../../helper/collection";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import StatusAlerts from "../ocean-insights/StatusAlerts.vue";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({ itemCode: "PORList" })
    );
    this.$store.dispatch("common/setAllAgentColoaderList");
    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Overseas Agent Assignments")
    ) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/ffExportFclConsolidation");
      this.getServicesData();
      this.getData();

    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    fclConsoMultipleModel: {
      handler: function (newVal, oldVal) {
        if (newVal.commodityId != "") {
          let arrayFilter = this.getCommodityData.filter((x) => {
            return x.commodityId == newVal.commodityId;
          })[0];

          if (arrayFilter.length > 0) {
            this.CommodityCallback(arrayFilter);
          }
        }

        if (newVal.clientId != "") {
          let arrayFilterClient = this.getCLientData.filter((x) => {
            return x.clientId == newVal.clientId;
          })[0];
          this.fclConsoMultipleModel.clientId = arrayFilterClient.clientId;
          this.fclConsoMultipleModel.clientName = arrayFilterClient.clientName;
        }
      },
      deep: true,
    },
    ffFclConsoModel: {
      handler: function (newVal, oldVal) {
        if (newVal.hasOwnProperty("PORlocationId") && newVal.PORlocationId != "") {
          let array = this.IcdPOrtList.filter((x) => {
            return x.pickupId == newVal.PORlocationId;
          })[0];
          console.log(this.IcdPOrtList, "aaq");
          console.log(array);

          this.ffFclConsoModel.portType = array.locationType;
          if (array.locationType != "Icd") {
            // this.ffFclConsoModel.LPlocationId = newVal.PORlocationId;
            // this.PortLoadList = this.IcdPOrtList;
          }
          this.deliveryTermsName[1].deliveryTermsText =
            "FOB_POR_ " + array.pickupLocation;
        }

        if (newVal.LPlocationId != "") {
          let array1 = this.PortLoadList.filter((x) => {
            return x.pickupId == newVal.LPlocationId;
          })[0];
          this.deliveryTermsName[2].deliveryTermsText =
            "FOB_LoadPort_ " + array1.pickupLocation;
        }

        if (newVal.containerInfo == "lcl") {
          this.ffFclConsoModel.stuffingType = "warehouseStuffing";
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      SUBSAlerts: [],
      // Added vy Priyanshu Singh Start
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },
      // Added vy Priyanshu Singh End
      showClientDiv: false,
      isLoading: false,
      trackingId: "",
      cctypeList: [
        {
          ccTypeVal: "Pridel",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "Outsourced",
          ccTypeTxt: "Outsourced",
        },
      ],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory Stuffing",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse Stuffing",
        },
      ],

      containerInfoName: [
        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation",
        },
        {
          containerInfoVal: "LclConsolidation",
          containerInfoText: "LCL Consolidation",
        },
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "Sea_Port",
          deliveryModeText: "Sea Port",
        },
        {
          deliveryModeVal: "ICD",
          deliveryModeText: "ICD",
        },
        {
          deliveryModeVal: "DOOR",
          deliveryModeText: "DOOR",
        },
      ],

      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],

      deliveryTermsName_bak: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],
      pdaDetailsName: [
        {
          pdaDetailsVal: "Pridel",
          pdaDetailsText: "Pridel",
        },
        {
          pdaDetailsVal: "Shipper",
          pdaDetailsText: "Shipper",
        },
        {
          pdaDetailsVal: "Liner",
          pdaDetailsText: "Liner",
        },
        {
          pdaDetailsVal: "NA",
          pdaDetailsText: "Not Applicable",
        },
      ],
      oceanFreightTermsName: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid",
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect",
        },
      ],
      prepaidDetailsName: [
        {
          prepaidDetailsVal: "C_F",
          prepaidDetailsText: "C & F",
        },
        {
          prepaidDetailsVal: "CIF",
          prepaidDetailsText: "CIF",
        },
      ],
      collectDetailsName: [
        {
          collectDetailsVal: "Ex_Works",
          collectDetailsText: "Ex Works",
        },
        {
          collectDetailsVal: "FOB_Place_Of_Receipt",
          collectDetailsText: "FOB Place Of Receipt",
        },
        {
          collectDetailsVal: "FOB_Load_Port",
          collectDetailsText: "FOB Load Port",
        },
      ],
      showAdd: false,

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin",
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination",
        },
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1",
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2",
        },
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
            this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      CommodityAll: {},
      autoClientName: {},
      ffFclConsoModel: {
        statusFinal: "",
        fclConsoMultipleClientId: "",
        ffFclConsoExportId: "",
        ffExportFclId: "",
        bookingSourceclientId: "",
        clientId: "",
        otherSpecifysource: "",
        ccCha: "",
        ccType: "",
        containerId: "",
        containerTypeId: "",
        ContainerType: "",
        no_of_container: "",
        portType: "",
        containerId: "",

        shippingId: "",
        shipType: "",
        coloaderName: "",
        shipmentType: "Sea_Shipment",
        transportType: "Export",
        stuffingType: "warehouseStuffing",
        containerInfo: "FclConsolidation",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "",
        pdaDetail: "Shipper",
        freeTimeAtOrigin: "7",
        freeTimeAtDestination: "7",

        remark: "",
        shipType: "",
        agentName: "",
        fk_agent_id: "",
        buyer: "",
        buyingHouse: "",

        jobType: [],

        FFExportFCLCreated: "",
        FFExportFCLUpdated: "",
      },
      newJobType: [],

      ffFclConsoModelError: {
        shippingId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        containerTypeId: "",
        no_of_container: "",
        deliveryMode: "",
      },
      ffFclConsoModelErrorArray: [
        "Please select shipping name",
        "Please select Place of Receipt",
        "Please select Load Port Name ",
        "Please select Place of Delievery",
        "Please select final Place of delievery",
        "Please select Container Type",
        "Please select No Of Container",
        "Please select Delivery Mode",
      ],
      fclConsoMultipleModel: {
        fclConsoMultipleClientId: "",
        ffFclConsoExportId: "",
        clientId: "",
        clientName: "",
        otherServices: [],
        additionalMoreTask: [],
        specificAdditionalTask: "",
        commodityId: "",
        commodityType: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        deliveryTerms: "",
      },

      //    fclConsoMultipleModelError: {
      //   clientId: "",
      //   commodityId: "",
      //   deliveryTerms: ""
      // },

      fclConsoMultipleModelError: {
        clientId: "",
        // commodityId: "",
        deliveryTerms: "",
      },
      FCLConMultipleClient: [],
      FCLCon: [],
      FclConsoDetailArray: [],

      fclConsoMultipleModelErrorArray: [
        "Please Select Client Name",
        "Please Select Commodity",
        "Please Select Delievery Terms",
      ],

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
            this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
            this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      errorAtleastOne: "",

      getPortDischargeList: [],
      finalAllPlaceData: [],
      PortLoadList: [],
      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment",
        },
      ],
      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: ["agra"],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
    };
  },

  mounted() { },
  beforeDestroy() { },
  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    StatusAlerts,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffFclConsoModel.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },
    shipmentTypeList() {
      return this.shipmentTypeName;
    },
    transportTypeList() {
      return this.transportTypeName;
    },

    stuffingTypeList() {
      return this.stuffingTypeName;
    },

    containerInfoList() {
      return this.containerInfoName;
    },

    deliveryModeList() {
      return this.deliveryModeName;
    },

    deliveryTermsList() {
      return this.deliveryTermsName;
    },

    pdaDetailList() {
      return this.pdaDetailsName;
    },
    oceanFreightTermsList() {
      return this.oceanFreightTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.agentListName;
    },
  },
  methods: {
    getContainerTypeDet(containerTypeId) {
      this.ffFclConsoModel.ContainerType = "";
      let filterArr = this.ContainerTypeList.filter(
        (item) => item.containerTypeId === containerTypeId
      );
      console.log('filterArr=>', filterArr)
      if (filterArr.length > 0) {
        this.ffFclConsoModel.ContainerType = filterArr[0].containerType;
      }

    },
    getAgentDetails() {
      this.ffFclConsoModel.fk_agent_id = "";
      let filterArr = this.$store.getters['common/getAllAgentColoaderList'].filter(
        (item) => item.agentName === agentName
      );
      console.log('filterArr=>', filterArr)
      if (filterArr.length > 0) {
        this.ffFclConsoModel.fk_agent_id = filterArr[0].agntColoaderId;
      }
    },
    validateFields() {
      this.FclConsoDetailArray.forEach((item) => {
        if (!item.deliveryTerms) {
          // if (!item.deliveryTerms || item.commodityId === "0" || !item.commodityId) {
          item.isValid = false;
        } else {
          item.isValid = true;
        }
      });
      let filterArr = this.FclConsoDetailArray.filter(
        (item) => item.isValid === false
      ).length;
      if (filterArr > 0) {
        this.validate = false;
      }
    },
    removeCommon(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.isfclConsoMultipleActive =
        item.isfclConsoMultipleActive == "1" ? 0 : 1;
      let paylod = {
        tableName: "ff_multipleclient_fclconso",
        tableId: "fclConsoMultipleClientId",
        tableIsActive: "isfclConsoMultipleActive",
        value1: this.itemObj.isfclConsoMultipleActive,
        tableVal: item.fclConsoMultipleClientId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    addMoreClient() {
      this.showClientDiv = true;
    },
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "8",
        allMessageId: this.$sessionsStorage.get("editffFclConsoExportId"),
        statusMain: this.ffFclConsoModel.statusFinal,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewEditMul(item) {
      window.scroll(0, 640);

      let array1 = [];
      let arrayAdditional = [];

      Object.keys(item).map((x) => {
        this.fclConsoMultipleModel[x] = item[x] || "";

        if (x == "otherServices") {
          array1 = item[x] ? item[x].split(",") : [];
        }
        if (x == "moreAdditionalTask") {
          arrayAdditional = item[x] ? item[x].split(",") : [];
        }
      });

      this.fclConsoMultipleModel["otherServices"] = [];
      this.fclConsoMultipleModel["additionalMoreTask"] = [];

      this.showAdditionalMoreTaskArray.map((x, index) => {
        let i = arrayAdditional.indexOf(x.value);

        i >= 0 ? this.fclConsoMultipleModel.additionalMoreTask.push(x) : "";
      });

      this.showOtherServiceArray.map((x, index) => {
        let i = array1.indexOf(x.value);

        i >= 0
          ? (this.fclConsoMultipleModel.otherServices[index] = true)
          : (this.fclConsoMultipleModel.otherServices[index] = false);
      });
      this.showClientDiv = true;
    },
    showMultiple() {
      this.fclConsoMultipleModel.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffFclConsoModel.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffFclConsoModel.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    CommodityCallback(item) {
      this.fclConsoMultipleModel.commodityId = item.commodityId;
      // this.fclConsoMultipleModel.commodityType = item.commodityType;
      this.fclConsoMultipleModel.itemDescription = item.itemDescription;
    },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffFclConsoModel.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffFclConsoModel.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },
    ProceedNext() {
      this.$router.push({
        path: "/ffExportCon/fclConsoBookingOrder",
      });
    },

    ProceedBookingOrder() {
      let newVal = [];

      this.showSegmentArray.map((x, index) => {
        if (this.ffFclConsoModel.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      this.ffFclConsoModel["jobType"] = newVal;

      let newData = {
        FCLCon: this.ffFclConsoModel,
        onlyFCLMain: "dfgdfg",
      };

      this.validateMainForm();
      this.validateFields();

      if (this.validate != false) {
        $("#addButtonLoaderS").css("display", "none");
        $("#loaderS").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addffConsolidationFcl.php`,
          // url: `${URL_BASE}/Api_FFSeaExport/addffConsolidationFclBak19112024.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoaderS").css("display", "block");
              $("#loaderS").css("display", "none");
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$refs["addPopInsert"].open();
              this.$sessionsStorage.set(
                "editffFclConsoExportId",
                data.ffFclConsoExportId
              );
              this.ffFclConsoModel.ffFclConsoExportId = data.ffFclConsoExportId;

              Object.keys(this.fclConsoMultipleModel).map((x) => {
                this.fclConsoMultipleModel[x] = "";
              });
            }
          })
          .catch((error) => { });
      }
    },
    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.ffFclConsoModel.jobType = Array(this.showSegmentArray.length).fill(true);
          this.jobTypeSelectVal = true;
        } else {
          this.ffFclConsoModel.jobType = Array(this.showSegmentArray.length).fill(false);
          this.jobTypeSelectVal = false;
        }
      }
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
    },

    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },

    getData() {
      this.doLoading();
      let array = [];
      let array1 = [];
      let arrayAdditional = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFFConFcl1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("result => ", data);

            if (data.CommodityData_new.length > 0) {
              // this.getCommodityData = data.CommodityData;
              this.getCommodityData = data.CommodityData_new;
            }

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            let arrayClentId = this.getCLientData.filter((x) => {
              return x.clientId == this.ffFclConsoModel.bookingSourceclientId;
            });

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;

            console.log(
              "LocationDetailsIcdIndiaSea => ",
              data.LocationDetailsIcdIndiaSea
            );

            this.finalAllPlaceData = data.LocationDetailsFinal;

            this.getShippingLineData = data.slineDetails;

            this.getContainerTypeData = data.containerMaster;

            if (
              this.$sessionsStorage.get("editffFclConsoExportId") != "" &&
              this.$sessionsStorage.get("editffFclConsoExportId") != undefined
            ) {
              console.log("1");
              let array_new = this.getCommodityData;

              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffFclConsoModel[x] = data.editFFEX[0][x] || "";
                if (x == "jobType") {
                  array = data.editFFEX[0][x].split(",");
                }
              });

              this.ffFclConsoModel["jobType"] = [];
              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ffFclConsoModel.jobType[index] = true)
                  : (this.ffFclConsoModel.jobType[index] = false);
              });

              //  alert();

              if (data.multipleClient && data.multipleClient.length > 0) {
                this.FclConsoDetailArray = data.multipleClient;
              }

              console.log("Job => ", this.FclConsoDetailArray);

              if (data.editFFEX[0]["portType"] == "Icd") {
                // this.IcdPOrtList = data.LocationDetailsFinal;
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              } else {
                //this.IcdPOrtList = data.LocationDetailsSEAPORT;
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              }
            } else {
              //this.IcdPOrtList = data.LocationDetailsSEAPORT;
              this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
            }

            console.log("finish");

            this.getTrackingDetails();

            this.doLoadingClose();
          }
        })
        .catch((error) => { });
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.ffFclConsoModel.allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
              this.getSingleSubscriptionsFunc(this.trackingId);
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch((error) => { });
    },
    async getSingleSubscriptionsFunc(trackingId) {
      this.SUBSAlerts = [];
      let payload = {};
      this.getSingleSubscriptions = {};
      payload = {
        itemCode: "getSingleSubscriptions",
        subscription_id: trackingId,
      };

      payload = JSON.stringify(payload);

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getSingleSubscriptions) {
              if (data.getSingleSubscriptions.containershipments.length > 0) {
                data.getSingleSubscriptions.containershipments.forEach(
                  (element, index) => {
                    if (element) {
                      if (element.pod_timeofarrival_warning) {
                        let type;
                        if (
                          element.pod_timeofarrival_warning.risk == 2 ||
                          element.pod_timeofarrival_warning.risk_verbose == "High Risk"
                        ) {
                          type = "alert-danger-text";
                        }
                        if (
                          element.pod_timeofarrival_warning.risk_verbose == "Low Risk"
                        ) {
                          type = "alert-warning";
                        }
                        if (element.pod_timeofarrival_warning.risk_verbose == "No Risk") {
                          type = "alert-info-text";
                        }
                        this.SUBSAlerts.push(
                          {
                            id: element.pod_timeofarrival_warning.risk,
                            ContainerNO: element.container_number,
                            ContainerType: element.container_type_iso,
                            type: type,
                            risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                            title: element.pod_timeofarrival_warning.risk_verbose,
                            message:
                              "Container No : " +
                              element.container_number +
                              " " +
                              element.pod_timeofarrival_warning.risk_description,
                            conclusion: element.pod_timeofarrival_warning.conclusion,
                          },
                          {
                            id: element.pod_timeofarrival_warning.risk + 1,
                            type: "alert-info-text",
                            risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                            title: "Conclusion",
                            ContainerNO: element.container_number,
                            ContainerType: element.container_type_iso,
                            message: element.pod_timeofarrival_warning.conclusion,
                            conclusion: element.pod_timeofarrival_warning.conclusion,
                          }
                        );
                      }
                    }
                  }
                );
              }
            }
            console.log("SUBSAlerts PS =>", this.SUBSAlerts);
          }
        })
        .catch((error) => {
          console.log("Catch on getSingleSubscriptions Error: ", error);
        });
    },
    // viewEditFFExport() {
    //   let array = [];
    //   let array1 = [];
    //   let arrayAdditional = [];
    //   let edit_SE = {
    //     editFFEX: "editFFEX",
    //     ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId")
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_FFSeaExport/viewEditFFConsolidationExport.php`,
    //     data: JSON.stringify(edit_SE),

    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId")
    //     }
    //   };

    //   axios(options)
    //     .then(result => {
    //       const { statusText, status, data } = result;

    //       if ( status == 200 && data) {
    //         let array_new = this.getCommodityData;

    //         Object.keys(data.editFFEX[0]).map(x => {
    //           this.ffFclConsoModel[x] = data.editFFEX[0][x] || "";
    //           if (x == "jobType") {
    //             array = data.editFFEX[0][x].split(",");
    //           }
    //         });

    //         this.ffFclConsoModel["jobType"] = [];
    //         this.showSegmentArray.map((x, index) => {
    //           let i = array.indexOf(x.value);

    //           i >= 0
    //             ? (this.ffFclConsoModel.jobType[index] = true)
    //             : (this.ffFclConsoModel.jobType[index] = false);
    //         });

    //         if (data.multipleClient.length > 0) {
    //           this.FclConsoDetailArray = data.multipleClient;
    //         }
    //       }
    //     })
    //     .catch(error => {});
    // },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/ffExportCon/viewFFConsoExport"
      // });
    },
    validateMultipleClient() {
      let validate_new = true;

      Object.keys(this.ffFclConsoModelError).map((x, index) => {
        if (this.ffFclConsoModel[x] == "") {
          this.ffFclConsoModelError[x] = this.ffFclConsoModelErrorArray[index];
          validate_new = false;
        }
      });

      Object.keys(this.fclConsoMultipleModelError).map((x, index) => {
        if (this.fclConsoMultipleModel[x] == "") {
          this.fclConsoMultipleModelError[x] = this.fclConsoMultipleModelErrorArray[
            index
          ];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    validateMainForm() {
      let validate_new = true;
      Object.keys(this.ffFclConsoModelError).map((x, index) => {
        if (this.ffFclConsoModel[x] == "") {
          this.ffFclConsoModelError[x] = this.ffFclConsoModelErrorArray[index];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addMultipleClient() {
      if (this.fclConsoMultipleModel.fclConsoMultipleClientId == "") {
        let arrayNew = this.FclConsoDetailArray.filter((x) => {
          return x.clientId == this.fclConsoMultipleModel.clientId;
        });

        if (arrayNew.length > 0) {
          this.fclConsoMultipleModel.clientId = "";
          this.alert.content = arrayNew[0].clientName + " Already Exist";
          this.$refs["addPop"].open();
          return false;
        }
      }
      let newVal = [];
      let newValOther = [];
      let newAdditionalTask = [];

      this.showSegmentArray.map((x, index) => {
        if (this.ffFclConsoModel.jobType[index] == true) {
          newVal.push(x.value);
        }
      });
      this.showOtherServiceArray.map((x, index) => {
        if (this.fclConsoMultipleModel.otherServices[index] == true) {
          newValOther.push(x.value);
        }
      });

      if (this.fclConsoMultipleModel.additionalMoreTask.length > 0) {
        this.fclConsoMultipleModel.additionalMoreTask.map((x, index) => {
          newAdditionalTask.push(x.value);
        });
      }

      this.ffFclConsoModel["jobType"] = newVal;
      this.fclConsoMultipleModel["ExtraWork"] = newValOther;
      this.fclConsoMultipleModel["additionalMoreTask"] = newAdditionalTask;

      let newData = {
        FCLCon: this.ffFclConsoModel,
        FCLConMultipleClient: this.fclConsoMultipleModel,
        onlyFCLMain: "",
      };

      this.validateMultipleClient();

      if (this.validate != false) {
        $("#addButtonLoaderMultiple").css("display", "none");
        $("#loaderMultiple").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addffConsolidationFcl.php`,
          // url: `${URL_BASE}/Api_FFSeaExport/addffConsolidationFclBak19112024.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoaderMultiple").css("display", "block");
              $("#loaderMultiple").css("display", "none");
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
              this.$sessionsStorage.set(
                "editffFclConsoExportId",
                data.ffFclConsoExportId
              );
              this.ffFclConsoModel.ffFclConsoExportId = data.ffFclConsoExportId;

              this.getData();
              Object.keys(this.fclConsoMultipleModel).map((x) => {
                this.fclConsoMultipleModel[x] = "";
              });
              Object.keys(this.fclConsoMultipleModelError).map((x) => {
                this.fclConsoMultipleModelError[x] = "";
              });
              this.showClientDiv = false;
            }
          })
          .catch((error) => { });
      }
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20",
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
      this.showOtherServiceArray = [
        {
          value: "Marking",
          show: "Marking/Labelling",
          flex: "20",
        },
        {
          value: "Palletization",
          show: "Palletization",
          flex: "15",
        },
        {
          value: "Fumigation",
          show: "Fumigation",
          flex: "15",
        },

        {
          value: "Lashing",
          show: "Lashing/Choking",
          flex: "20",
        },
        {
          value: "None",
          show: "None",
          flex: "15",
        },
      ];

      this.showAdditionalMoreTaskArray = [
        {
          value: "Legalization",
          show: "Legalization",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
        },
        {
          value: "Phyto",
          show: "Phyto",
        },

        {
          value: "APEDA",
          show: "APEDA",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
        },

        {
          value: "WildlifeNOC",
          show: "Wildlife NOC",
        },
        {
          value: "Insurance",
          show: "Insurance",
        },

        {
          value: "OthersSpecify",
          show: " Others Specify",
        },
      ];
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              console.log("MyData=>", data);
              console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => { });
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}

.icon-1 {
  color: white !important;
}

.md-fab {
  position: fixed;
  z-index: 999;
  top: 83%;
  background-color: #002b49 !important;
}

.md-fab:hover {
  background-color: #d81b60 !important;
}
</style>



// WEBPACK FOOTER //
// ffExportFclConsolidation.vue?1e97029a